/**
 * Get the file extensions from a URL or path
 */
export default function getFileExtension(URL) {
  if (typeof URL !== 'string' || URL === '') return false;
  if (URL.indexOf('.') < 0) return false;

  return URL.split('.').pop();
}
